<div class="se-timeline-toggle-container">
    <button color="accent"
            mat-icon-button
            [matTooltip]="tooltip"
            (click)="_showHideTimeline()">
        <mat-icon *ngIf="toggleOpen">keyboard_double_arrow_up</mat-icon>
        <mat-icon *ngIf="!toggleOpen">keyboard_double_arrow_down</mat-icon>
    </button>
</div>
